import React, { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/hooks';
import { Loading } from '@/components/common';
import { ROUTES } from '@/utils/constants';

interface ProtectedRouteProps {
    allowedRoles?: string[];
    children?: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ allowedRoles, children }) => {
  const { isAuthenticated, isLoading, validateToken, user } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) {
      validateToken();
    }
  }, [isAuthenticated, validateToken]);

  if (isLoading) {
    return <Loading size="lg" text="جاري التحقق من الجلسة..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  if (allowedRoles && user && !allowedRoles.includes(user.role)) {
      // User not authorized
      return <Navigate to={ROUTES.SEARCH} replace />; // Redirect to a default safe page or Unauthorized page
  }

  return children ? <>{children}</> : <Outlet />;
};
